/**
 * SIM:ON → human handoff ("Speak to a human? WhatsApp an expert").
 * Shared by every SIM:ON chat surface. Call after each finished SIM:ON reply:
 *   window.OGSimonHandoff && OGSimonHandoff.show({
 *     before: formEl,          // strip is inserted directly above this element
 *     history: [{role,content}],
 *     sid: 'web-…',            // logged session id (optional; adds a ref Tom can look up)
 *     source: 'sim-on',        // GA4 label for the surface
 *     topic: 'a golf simulator', // what the visitor is shopping for
 *     theme: 'dark'|'light'
 *   });
 * The WhatsApp message is pre-filled from what the visitor has told SIM:ON so far.
 */
(function () {
  'use strict';
  if (window.OGSimonHandoff) return;

  var WA = '447717305356';
  var WA_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.26-.47-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.57-.35M12.05 21.79h-.01a9.87 9.87 0 01-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 012.89 6.99c0 5.45-4.44 9.88-9.89 9.88M20.46 3.49A11.82 11.82 0 0012.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 005.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.17-3.48-8.42z"/></svg>';

  var CSS =
    '.og-hoff{display:flex;align-items:center;gap:10px;border-radius:12px;padding:9px 12px;margin:0 0 10px;text-decoration:none!important;cursor:pointer;transition:border-color .15s,background .15s;-webkit-tap-highlight-color:transparent}' +
    '.og-hoff__ic{flex:0 0 30px;width:30px;height:30px;border-radius:50%;background:#25D366;color:#fff;display:flex;align-items:center;justify-content:center}' +
    '.og-hoff__t{flex:1;min-width:0;line-height:1.25}' +
    '.og-hoff__t b{display:block;font-size:13.5px;font-weight:800}' +
    '.og-hoff__t span{display:block;font-size:11.5px;margin-top:1px}' +
    '.og-hoff__go{flex:0 0 auto;color:#25D366;font-weight:800;font-size:16px}' +
    '.og-hoff--dark{background:rgba(37,211,102,.12);border:1px solid rgba(37,211,102,.55)}' +
    '.og-hoff--dark:hover{background:rgba(37,211,102,.18);border-color:#25D366}' +
    '.og-hoff--dark .og-hoff__t b{color:#fff}.og-hoff--dark .og-hoff__t span{color:#9fd9b6}' +
    '.og-hoff--light{background:#effbf3;border:1px solid #9fe3b8}' +
    '.og-hoff--light:hover{border-color:#25D366}' +
    '.og-hoff--light .og-hoff__t b{color:#101614}.og-hoff--light .og-hoff__t span{color:#3d6b50}' +
    '.og-hoff--light .og-hoff__go{color:#128C4C}';

  function injectCss() {
    if (document.getElementById('og-hoff-css')) return;
    var st = document.createElement('style');
    st.id = 'og-hoff-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  // Pull the useful facts out of what the visitor typed, so Tom doesn't have to re-ask.
  var DIM = /\d[\d.,]*\s*(?:m|cm|mm|ft|feet|foot|metres?|meters?|'|′|’)?\s*(?:\d+\s*(?:"|″|in|inches)?\s*)?(?:x|×|by|\*)\s*\d[\d.,]*\s*(?:m|cm|mm|ft|feet|foot|metres?|meters?|'|′|’)?\s*(?:\d+\s*(?:"|″|in|inches)?\s*)?(?:(?:x|×|by|\*)\s*\d[\d.,]*\s*(?:m|cm|mm|ft|feet|foot|metres?|meters?|'|′|’)?\s*(?:\d+\s*(?:"|″|in|inches)?)?)?/i;
  var BUDGET = /£\s?\d[\d,.]*\s?k?|\bbudget\b[^\d£\n]{0,20}(\d[\d,.]*\s?k?)/i;

  function clip(s, n) { s = String(s).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n - 1) + '…' : s; }

  function buildText(o) {
    var users = (o.history || []).filter(function (m) { return m && m.role === 'user' && m.content; })
      .map(function (m) { return String(m.content); });
    var all = users.join('\n');
    var room = all.match(DIM), budget = all.match(BUDGET);
    var t = 'Hi, I’ve been chatting with SIM:ON about ' + (o.topic || 'a golf simulator') + ' and would like to speak to you.';
    if (room) t += '\nRoom: ' + clip(room[0], 40);
    if (budget) t += '\nBudget: ' + clip(budget[1] || budget[0], 20);
    if (!room && !budget && users.length) t += '\nMy question: “' + clip(users[0], 140) + '”';
    if (o.sid) t += '\n(SIM:ON chat ref ' + String(o.sid).slice(-6) + ')';
    return t;
  }

  function track(o, turns) {
    try {
      if (typeof gtag === 'function') gtag('event', 'whatsapp_consult_click', {
        event_category: 'simon', location: 'simon_chat_handoff', placement: o.source || 'unknown', simon_turns: turns
      });
    } catch (e) {}
  }

  function show(o) {
    if (!o || !o.before || !o.before.parentNode) return;
    injectCss();
    var a = o.before.previousElementSibling;
    if (!a || !a.classList || !a.classList.contains('og-hoff')) {
      a = document.createElement('a');
      a.className = 'og-hoff og-hoff--' + (o.theme === 'light' ? 'light' : 'dark');
      a.target = '_blank';
      a.rel = 'noopener';
      a.innerHTML = '<span class="og-hoff__ic">' + WA_ICON + '</span>' +
        '<span class="og-hoff__t"><b>Speak to a human? WhatsApp an expert</b>' +
        '<span>Our ' + (o.expert || 'sim expert') + ' · usually replies within the hour</span></span>' +
        '<span class="og-hoff__go" aria-hidden="true">→</span>';
      a.addEventListener('click', function () {
        var st = a.__ogHoff || o;
        var turns = (st.history || []).filter(function (m) { return m && m.role === 'user'; }).length;
        track(st, turns);
      });
      o.before.parentNode.insertBefore(a, o.before);
    }
    a.__ogHoff = o;
    var text = buildText(o);
    try { var ref = window.__ogGetRef && window.__ogGetRef(); if (ref) text += '\n\n' + ref; } catch (e) {}
    a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text);
    // Let the sitewide click-id tagger re-tag the rebuilt link.
    a.removeAttribute('data-og-tagged');
    if (text.indexOf('[ref:') !== -1) a.setAttribute('data-og-tagged', '1');
  }

  // ── Auto-attach to every SIM:ON chat surface on the page ──
  // The strip appears as soon as the visitor has sent a message, and its WhatsApp text is
  // rebuilt after each new message. sidKey = the sessionStorage key a surface logs under.
  var SURFACES = [
    { root: '#som-ask', user: '.som-ask__msg--user', form: '#som-form', sidKey: 'og_ask_sid', source: 'som-ask' },
    { root: '[data-og-ask]', user: '.og-ask__msg--user', form: '[data-og-ask-form]', sidKey: 'og_pdpask_sid', source: 'og-ask' },
    { root: '[data-simon-veil]', user: '.ogfab-msg--user', form: '[data-simon-form]', sidKey: 'og_fab_sid', source: 'home-modal' },
    { root: '#og-simon-modal', user: '.og-si-msg--user', form: '#og-simon-form', sidKey: 'og_simon_session', source: 'pdp-modal' }
  ];

  // Light or dark strip, from the first opaque background behind the form.
  function themeFor(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var c = getComputedStyle(n).backgroundColor, m = c && c.match(/[\d.]+/g);
      if (!m || (m.length > 3 && +m[3] < 0.5)) continue;
      return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) < 140 ? 'dark' : 'light';
    }
    return 'light';
  }

  // Once a visitor engages with SIM:ON, other OG popups (email capture etc.) must not cover the
  // chat: they all yield when the shared __ogModal coordinator is marked pending.
  function markActive() {
    window.__ogModal = window.__ogModal || { open: false, pending: false };
    window.__ogModal.pending = true;
    try { sessionStorage.setItem('og_simon_active', '1'); } catch (e) {}
  }
  try { if (sessionStorage.getItem('og_simon_active') === '1') markActive(); } catch (e) {}

  function sid(key) { try { return key ? sessionStorage.getItem(key) || '' : ''; } catch (e) { return ''; } }

  function wire(cfg, root) {
    if (root.__ogHoffWired) return;
    var form = root.querySelector(cfg.form);
    if (!form) return;
    root.__ogHoffWired = true;
    root.addEventListener('focusin', markActive);
    root.addEventListener('pointerdown', markActive);
    var title = root.getAttribute('data-title') || '';
    var cage = /cage|net\b/i.test(title);
    var theme = null, last = '', counted = 0;
    function update() {
      var users = root.querySelectorAll(cfg.user);
      if (!users.length) return;
      // GA4 chat funnel: one event per visitor message (1st, 2nd, 3rd…) per surface.
      if (users.length > counted) {
        counted = users.length;
        try { if (typeof gtag === 'function') gtag('event', 'simon_chat_message', { placement: cfg.source, message_number: counted }); } catch (e) {}
      }
      var key = users.length + '|' + sid(cfg.sidKey) + '|' + (users[users.length - 1].textContent || '').length;
      if (key === last) return;
      last = key;
      markActive();
      // The page-level 'Prefer a human?' banner duplicates the in-chat strip once chatting.
      var dup = document.querySelectorAll('.som2-wa');
      for (var d = 0; d < dup.length; d++) dup[d].style.display = 'none';
      var history = [];
      for (var i = 0; i < users.length; i++) {
        var b = users[i].querySelector('.og-si-msg-bubble') || users[i];
        history.push({ role: 'user', content: b.textContent || '' });
      }
      theme = theme || themeFor(form);
      show({
        before: form, history: history, sid: sid(cfg.sidKey), source: cfg.source, theme: theme,
        topic: title ? 'the ' + title : 'a golf simulator', expert: cage ? 'golf expert' : 'sim expert'
      });
    }
    new MutationObserver(update).observe(root, { childList: true, subtree: true });
    update();
  }

  function scan() {
    SURFACES.forEach(function (cfg) {
      var roots = document.querySelectorAll(cfg.root);
      for (var i = 0; i < roots.length; i++) wire(cfg, roots[i]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();

  window.OGSimonHandoff = { show: show, scan: scan, _text: buildText };
})();
